export const getShareURL = (pageType, category, id, relativePath = false) => {
    const pre = relativePath ? "/" : process.env.REACT_APP_ANNUAL_URL.replace(/\/$/, "")

    switch (pageType) {
        case 'entry':
            return `${pre}entry/${category}/${id}/`
        case 'article':
            if (category === "in-memoriam") {
                return `${pre}people/in-memoriam/${id}/`
            }
            return `${pre}editorial/${id}/`
        default:
            return ""
    }
}

export const getYouTubeId = (url) => {
    if (!url.includes("v=")) return null;
    let video_id = url.split('v=')[1];
    let ampersandPosition = video_id.indexOf('&');
    if(ampersandPosition != -1) {
        video_id = video_id.substring(0, ampersandPosition);
    }
    return video_id
}

export const selectImageUrl = (images, label) => {
    const img = images.find(i => i.label === label)
    return img ? img.url : ''
}